import { css } from '@emotion/react';
import { animation } from '@pairy/styles';

export const pulse = css`
  animation: ${animation.pulse('79, 88, 96')} 2.5s infinite;
`;
